import { useQuery } from "@tanstack/react-query";
import auditCodeService from "../../../../services/auditCodeService";

export const auditCodeQueryKey = (storeId: string) => ["audit-codes", storeId] as const;

export const useAuditCodes = (storeId: string) => {
    return useQuery({
        queryKey: auditCodeQueryKey(storeId),
        queryFn: () => auditCodeService.listAuditCodes(storeId),
        enabled: Boolean(storeId),
        staleTime: 60 * 1000,
    });
};
